import React, { useState } from 'react';
import { Dropdown } from 'antd';
import { HistoryOutlined, MoreOutlined, FileTextOutlined } from '@ant-design/icons';
import { isNotEmpty } from 'ramda';
import { Link } from 'react-router-dom';

const FrameDropdown = ({ hasComparisonInProgress, setInfosFrameId, comparisons, id }) => {
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const items = [
    {
      key: `details-${id}`,
      icon: <FileTextOutlined />,
      label: <Link to={`/trames/${id}/informations/`}>Voir la trame détaillée</Link>,
      className: 'btn-see-frame-details'
    },
    ...(isNotEmpty(comparisons)
      ? [{
        key: `history-${id}`,
        icon: <HistoryOutlined />,
        onClick: () => setInfosFrameId(id),
        label: 'Voir la dernière comparaison',
        className: 'btn-last-comparison'
      }]
      : [])
  ];

  return (
    <div className="flex justify-end gap-2 text-lg">
      <Dropdown
        menu={{ items }}
        open={dropdownVisible}
        onOpenChange={setDropdownVisible}
        overlayClassName="modular-dropdown"
        trigger={['click']}
        disabled={hasComparisonInProgress}
      >
        <MoreOutlined className={`!text-flexi-grey ${hasComparisonInProgress ? 'cursor-not-allowed' : 'cursor-pointer'}`} />
      </Dropdown>
    </div>
  );
};

export default FrameDropdown;
